export default __webpack_public_path__ + "static/media/3.c5403dde.jpg";